export const setupZoomHandler = () => {
  // Prevent zoom on double tap
  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    (event) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  // Prevent zoom on pinch
  document.addEventListener(
    "touchmove",
    (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  // Handle input focus and blur
  const handleZoom = () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    const viewportContent =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0";

    if (viewport) {
      viewport.setAttribute("content", viewportContent);
    } else {
      const meta = document.createElement("meta");
      meta.name = "viewport";
      meta.content = viewportContent;
      document.head.appendChild(meta);
    }
  };

  // Force reset zoom level on input focus
  document.addEventListener("focusin", (e) => {
    if (
      e.target.tagName.toLowerCase() === "input" ||
      e.target.tagName.toLowerCase() === "textarea" ||
      e.target.tagName.toLowerCase() === "select"
    ) {
      handleZoom();
      // Force redraw
      document.body.style.transform = "scale(1)";
      setTimeout(() => {
        document.body.style.transform = "";
      }, 0);
    }
  });

  // Reset zoom on blur
  document.addEventListener("focusout", (e) => {
    if (
      e.target.tagName.toLowerCase() === "input" ||
      e.target.tagName.toLowerCase() === "textarea" ||
      e.target.tagName.toLowerCase() === "select"
    ) {
      handleZoom();
      // Force redraw
      window.scrollTo(0, 0);
    }
  });

  // Initial setup
  handleZoom();
};
